import React, { FormEvent, useEffect, useState } from 'react'

import { ComponentMethod } from '../../../types/component';

import useSaveNotificationComponent from '../../../hooks/notification_components/useSaveNotificationComponent';
import useDeleteNotificationComponent from '../../../hooks/notification_components/useDeleteNotificationComponent';

import { INotificationComponent, ISaveNotificationComponent, TLogicalOperator } from '../../../types/custom_notifications';

interface INotificationComponentProps {
    notificationComponent: INotificationComponent;
    currOption: number[];
    setCurrOption: React.Dispatch<React.SetStateAction<number[]>>;
    isDelete: boolean;
    setIsDelete: React.Dispatch<React.SetStateAction<boolean>>;
    setIsOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
    setIsResetNew: React.Dispatch<React.SetStateAction<boolean>>;
    setDeleteModalMessage: React.Dispatch<React.SetStateAction<{ title: string; subtitle: string; }>>;
};

const NotificationComponent = ({ notificationComponent, currOption, setCurrOption, isDelete, setIsDelete, setIsOpenDeleteModal, setIsResetNew, setDeleteModalMessage }: INotificationComponentProps) => {
    const [title, setTitle] = useState<string>(notificationComponent.id ? notificationComponent.description : 'New Notification Component');

    const [currentNotificationComponent, setCurrentNotificationComponent] = useState<INotificationComponent>(notificationComponent);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [apiError, setApiError] = useState<string | null>(null); //eslint-disable-line

    useEffect(() => {
        setCurrentNotificationComponent(notificationComponent);
        setTitle(notificationComponent.id ? notificationComponent.description : 'New Notification Component');
    }, [notificationComponent]);

    const { mutate: saveNotificationComponent } = useSaveNotificationComponent();
    const { mutate: deleteNotificationComponent } = useDeleteNotificationComponent();

    useEffect(() => {
        if (isDelete) {
            if (currOption.length - 1 === 1) {
                setCurrOption([currOption[0]]);
            } else {
                setCurrOption([currOption[0], 0]);
            }
            if (!notificationComponent.id) return;
            deleteNotificationComponent({
                id: notificationComponent.id,
                setIsProcessing,
                setApiError,
            });
            setIsDelete(false);
        }
    }, [isDelete]); //eslint-disable-line

    if (!currentNotificationComponent) {
        return <p>Loading...</p>
    }

    const handleSave = (e: FormEvent) => {
        e.preventDefault();

        const payload: ISaveNotificationComponent = {
            id: currentNotificationComponent.id ?? null,
            description: currentNotificationComponent.description,
            custom_notification_id: currentNotificationComponent.custom_notification_id,
            method: currentNotificationComponent.method,
        };

        saveNotificationComponent({
            data: payload,
            setIsProcessing,
            setApiError,
        });

        setTitle(currentNotificationComponent.description || 'New Component');
    }

    const handleDelete = () => {
        if (!notificationComponent.id) {
            setIsResetNew(true);
            setIsResetNew(true);
            if (currOption.length - 1 === 1) {
                setCurrOption([currOption[0]]);
            } else {
                setCurrOption([currOption[0], 0]);
            }
        } else {
            setDeleteModalMessage({ title: 'Delete Notification Component', subtitle: 'This will delete all the functions and parameters associated with the component. Are you sure you want to delete?' });
            setIsOpenDeleteModal(true);
        }
    }


    return (
        <div className='imm_admin__content'>
            <div className='content_head'>
                <h3>{notificationComponent.id ? 'Component - ' : ''} {title.slice(0, 40) + (title.length > 40 ? ' ...' : '')}</h3>
            </div>

            <form onSubmit={handleSave} className='content_form'>
                <div className='field'>
                    <label htmlFor='description'>Description <span className='field__required'>*</span></label>
                    <textarea id='description' name='description' placeholder='Enter Description' value={currentNotificationComponent.description || ""} onChange={(e) => setCurrentNotificationComponent({ ...currentNotificationComponent, description: e.target.value })}></textarea>
                </div>

                <div className='field'>
                    <label htmlFor='method'>Method <span className='field__required'>*</span></label>
                    <select id='method' name='method' value={currentNotificationComponent.method} onChange={(e) => setCurrentNotificationComponent({ ...currentNotificationComponent, method: e.target.value as TLogicalOperator })}>
                        <option value={ComponentMethod.AND}>and</option>
                        <option value={ComponentMethod.OR}>or</option>
                    </select>
                </div>

                <div className='actions'>
                    <button className='delete_btn' disabled={isProcessing} type="button" onClick={handleDelete}>{!notificationComponent.id ? 'Cancel' : 'Delete'}</button>
                    <button className='save_btn' type='submit'>{isProcessing ? <i className='imm_admin__process_loader' /> : !notificationComponent.id ? 'Create' : 'Save'}</button>
                </div>
            </form>
        </div>
    );
}

export default NotificationComponent;